export const translateComponent = (translations, language, component, key) => {
  return translations[language]?.["components"]?.[component]?.[key] ?? "";
};
export const translatePage = (translations, language, page, key) => {
  return translations[language]?.["pages"]?.[page]?.[key] ?? "";
};
